import dynamic from "next/dynamic";
import React   from "react";

import { storeCTEvent }  from "_analytics/index";
import Toast             from "_common/toast";
import { getBaseURL }    from "_common/utils";
import { getDeviceType } from "_common/utils/user";

const Presentation       = dynamic ( () => import ( "./presentation" ) );
const PresentationMobile = dynamic ( () => import ( "./presentationMobile" ) );

const component = props => {

	const onClickHandler = props => {
		const {
			type,
			id,
			isDeleted
		} = props;

		if ( isDeleted === 1 )
			return Toast.error ( "Deleted content no longer exists." );

		switch ( type ) {
			case "gaming": {
				handleOpenLink ( `${ getBaseURL () }/stream/${ id }` );

				const ctOptions = {
					eventProperty : "content_clicked",
					value         : "broadcast"
				};

				storeCTEvent ( "creator_dashboard_navigation", ctOptions );
				break;
			}

			case "IRL": {
				handleOpenLink ( `${ getBaseURL () }/stream/${ id }` );

				const ctOptions = {
					eventProperty : "content_clicked",
					value         : "broadcast"
				};

				storeCTEvent ( "creator_dashboard_navigation", ctOptions );

				break;
			}

			case "uploaded_av_content": {
				handleOpenLink ( `${ getBaseURL () }/video/${ id }` );

				const ctOptions = {
					eventProperty : "content_clicked",
					value         : "videos"
				};

				storeCTEvent ( "creator_dashboard_navigation", ctOptions );
				break;
			}

			case "reel": {
				handleOpenLink ( `${ getBaseURL () }/video/${ id }` );

				const ctOptions = {
					eventProperty : "content_clicked",
					value         : "reels"
				};

				storeCTEvent ( "creator_dashboard_navigation", ctOptions );
				break;
			}

			default:
				break;
		}
	};

	const handleOpenLink = url => {
		if ( getDeviceType () === "android" ) {
			window?.Android?.openBrowser ( url );

			return;
		}

		if ( getDeviceType () === "ios" ) {
			// Send a message with arguments to the native iOS code
			let dataToSend = {
				action    : "openBrowser", // action is always name of the JS function
				arguments : {
					url
				}
			};

			window?.webkit?.messageHandlers?.ios_handler?.postMessage ( JSON.stringify ( dataToSend ) );

			return;
		}
		window.open ( url, "_blank" );
	};

	if ( props?.isMobile )
		return (
			<PresentationMobile
				onClickHandler = { onClickHandler }
				{ ...props }
			/>
		);

	return (
		<Presentation
			onClickHandler = { onClickHandler }
			{ ...props }
		/>
	);
};

export default component;

